<div class="about">
  <div class="abt-container">
    <div class="left-hero">
      <div class="intro-wrap">
        <h1 class="title">
          {{
            school?.heading
              ? school?.heading
              : "Inspiring Minds, Shaping Futures."
          }}
        </h1>
        <p class="description">
          {{
            school?.subHeading
              ? school?.subHeading
              : "Empowering students with knowledge, values, and skills for a brighter tomorrow."
          }}
        </p>
      </div>
      <div class="actions">
        <button
          mat-raised-button
          color="primary"
          (click)="openFormDialog()"
          class="enquire"
        >
          Enquire about admissions
        </button>
        <button
          mat-raised-button
          color="primary"
          class="btn"
          (click)="openVisitForm()"
        >
          Book a visit
        </button>
      </div>
    </div>
    <div class="slide-wrapper">
      <div class="slideshow">
        <div
          class="images-wrapper"
          [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
          [style.transition]="'transform 1.5s ease-in-out'"
        >
          <div
            class="image-container"
            *ngFor="let image of images; let i = index"
            (click)="openImage(i)"
          >
            <img [src]="image.url" alt="Slideshow Image" />
          </div>
        </div>
      </div>
      <div class="layer-2"></div>
      <div class="overlay" *ngIf="showOverlay">
        <div class="overlay-content">
          <img [src]="images[overlayIndex]?.url" alt="Selected Image" />
          <!-- <div
            class="slide-image"
            [style.background-image]="'url(' + images[overlayIndex]?.url + ')'"
          ></div> -->
        </div>
        <button class="nav left" (click)="prevImage()"><</button>
        <button class="nav right" (click)="nextImage()">></button>
        <button class="close" (click)="closeOverlay()">✖</button>
      </div>
    </div>
  </div>
</div>
